import { gql } from '@apollo/client';
import orgsAndUnitsFragment from '../../shared/queries/orgsAndUnitsFragment';

const GET_ORGS_AND_UNITS_WITH_APPROVED_MDDAP_APPRAISAL = gql`
  query GetOrgsAndUnitWithApprovedMddapAppraisalQuery($orgId: Int) {
    orgsAndUnitsWithApprovedMddapAppraisal(orgId: $orgId) {
      ...OrgAndUnitsFields
    }
  }
  ${orgsAndUnitsFragment}
`;

export default GET_ORGS_AND_UNITS_WITH_APPROVED_MDDAP_APPRAISAL;
